module.exports = __webpack_public_path__ + "static/media/logo-ama.c6c0a36b.png";